<app-card-base
  [title]="'Se connecter'"
  [hasSubmit]="true"
  [submitText]="b2cUser ? 'Se connecter' : 'Suivant'"
  (submitEvent)="onSubmit()"
  [loading]="loading"
  [isDisabled]="loginForm.invalid || (b2cUser && !passwordFilled)"
>
  <ng-container main *ngTemplateOutlet="content"></ng-container>
  <ng-container footer *ngTemplateOutlet="footer"></ng-container>
</app-card-base>

<ng-template #content>
  <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
    <div>
      <!-- email -->
      <mat-form-field class="col-12">
        <mat-label>Adresse Email</mat-label>
        <input
          type="email"
          matInput
          formControlName="username"
          placeholder="Adresse Email"
          required
          autocomplete="username"
          name="username"
          id="username"
        />
        @if (f('username').value) {
          <mat-icon matSuffix role="button" appTooltip="Supprimer l'adresse mail" (click)="resetLogin()"
            >close</mat-icon
          >
        }
        @if (f('username').hasError('required')) {
          <mat-error>
            <span>Veuillez saisir votre adresse email</span>
          </mat-error>
        }
        @if (f('username').hasError('email')) {
          <mat-error>
            <span>Veuillez saisir une adresse email valide</span>
          </mat-error>
        }
        @if (f('username').hasError('unknownEmail')) {
          <mat-error>
            <span>Email inconnu. Vérifiez-le ou créez votre compte.</span>
          </mat-error>
        }
      </mat-form-field>
      <!-- password b2c -->
      @if (b2cUser) {
        <mat-form-field class="col-12">
          <mat-label>Mot de passe</mat-label>
          <input
            [type]="hidePassword ? 'password' : 'text'"
            #password
            matInput
            formControlName="password"
            placeholder="Mot de passe"
            autocomplete="current-password"
            (keyup.enter)="onSubmit()"
            (ngModelChange)="onPasswordCHange($event)"
          />
          <mat-icon
            matSuffix
            role="button"
            [appTooltip]="hidePassword ? 'Afficher le mot de passe' : 'Masquer le mot de passe'"
            (click)="hidePassword = !hidePassword"
            >{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon
          >
          @if (f('password').hasError('required')) {
            <mat-error>
              <span>Veuillez saisir votre mot de passe</span>
            </mat-error>
          }
        </mat-form-field>
      }
    </div>
  </form>
</ng-template>

<ng-template #footer>
  <!-- forgot -->
  @if (b2cUser) {
    <div class="text-end mt-3">
      <a routerLink="/password-lost" [queryParams]="getQueryParams()">Mot de passe oublié ?</a>
    </div>
  }
  @if (!b2cUser) {
    <div class="create-account">
      <button mat-flat-button color="primary" routerLink="/register" [queryParams]="getQueryParams()">
        Créer son compte gratuitement
      </button>
    </div>
  }
</ng-template>
